import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import DatePicker from '../../../LaridaeApp/datepicker/container/DatePicker'
import { obtenerTotalAlmacenaje } from '../../actions/listados'
import TotalAlmacenajeView from '../../components/listados/TotalAlmacenajeView'

function TotalAlmacenaje (props) {
  const { obtenerTotalAlmacenaje } = props

  useEffect(() => {
    obtenerTotalAlmacenaje(new Date(), new Date())
  }, [obtenerTotalAlmacenaje])

  const actualizarFechas = (fechaD, fechaH) => {
    obtenerTotalAlmacenaje(fechaD, fechaH)
  }

  return (
    <>
      <div className='container-entre-fechas' style={{ margin: '0 auto' }}>
        <DatePicker
          selectRange
          disabledFuture
          locale='es'
          onDateChange={actualizarFechas}
          titulo='Seleccione las fechas'
          value='fechas'
        />
      </div>

      <TotalAlmacenajeView />
    </>
  )
}

const mapActionsToProps = {
  obtenerTotalAlmacenaje
}

const withRedux = connect(null, mapActionsToProps)
export default withRedux(TotalAlmacenaje)
